import { useState } from 'react';
import { FaDownload } from "react-icons/fa6";
import { GrDocumentText } from "react-icons/gr";
import { useSpecificLoanAgreements } from "../../../services/hooks/getAdminapis";
import ShimmerLoader from "../../utilComponents/shimmer";

const ITEMS_PER_PAGE = 5;

const AllDocs = () => {
    const { data: allLoanAgreements, isLoading, error } = useSpecificLoanAgreements();
    const [viewDocUrl, setViewDocUrl] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    const handleView = (url) => setViewDocUrl(url);
    const handleCloseModal = () => setViewDocUrl(null);

    if (isLoading) return <ShimmerLoader width='100%' height='200px' />;
    if (error) return <p>Error loading documents.</p>;
    if (!allLoanAgreements?.success || !allLoanAgreements.data?.length) {
        return <p>No documents found.</p>;
    }

    const totalItems = allLoanAgreements.data.length;
    const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);

    const paginatedData = allLoanAgreements.data.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    return (
        <div>
            <h2>All Documents</h2>

            <table border="1" cellPadding="8" cellSpacing="0" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>LendeeAccountID</th>
                        <th>Created By</th>
                        <th>Documents</th>
                    </tr>
                </thead>
                <tbody>
                    {paginatedData.map(doc => (
                        <tr key={doc._id}>
                            <td>{new Date(doc.createdAt).toLocaleDateString()}</td>
                            <td>{doc.LendeeAccountID}</td>
                            <td>{doc.createdBy}</td>
                            <td className='flex justify-content-evenly align-items-center'>
                                <span title="View Document" onClick={() => handleView(doc.officeViewUrl)} style={{ cursor: 'pointer' }}>
                                    <GrDocumentText size={25} color='#b59f5b' />
                                </span>
                                <a href={doc.docLink} download title="Download Document">
                                    <FaDownload size={25} color='green' />
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Pagination Controls */}
            <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
                    Prev
                </button>
                <span>{currentPage} of {totalPages}</span>
                <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>
                    Next
                </button>
            </div>

            {/* Modal / viewer */}
            {viewDocUrl && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center',
                }}>
                    <div style={{ background: 'white', padding: '20px', width: '80%', height: '80%' }}>
                        <button onClick={handleCloseModal} style={{ float: 'right' }}>Close</button>
                        <iframe src={viewDocUrl} title="Document Viewer" style={{ width: '100%', height: '100%' }} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default AllDocs;
